<template>
  <div class="card-body">
    <div class="row">
      <valuation-editor
        ref="valuationEditor"
        :valuation="valuation"
        :valuationDocuments="valuationDocuments"
      />
      <div class="col-12 mt-4 d-flex justify-content-end">
        <button class="btn btn-danger" type="button" @click="cancel">
          Cancel
        </button>
        <button class="btn btn-primary ms-3" type="submit" @click="saveDetails">
          Save
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ValuationEditor from "./ValuationEditor.vue";

export default {
  name: "ValuationEditorModal",
  components: { ValuationEditor },
  props: {
    valuation: {
      type: Object,
    },
    valuationDocuments: {
      type: Array,
      default: () => [],
    },
    onDelete: {
      type: Function,
      default: null,
    },
  },
  methods: {
    cancel() {
      if (!this.valuation.id) {
        this.onDelete();
      }
      this.close();
    },
    close(state = null) {
      this.$modal.hide("valuation-editor-modal", state);
    },
    async saveDetails() {
      if (this.$refs.valuationEditor.isInvalid()) return;

      this.close({ value: this.$refs.valuationEditor.valuation_ });
    },
  },
};
</script>
